import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import ApiHelper from '../../helperFunction/ApiHelper'
import API_ENDPOINTS from '../../helperFunction/Constant'
import { Link, useNavigate } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Toast } from 'primereact/toast'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'


const Orders = () => {

    const toast = useRef(null)
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [orders, setOrders] = useState([])
    const navigate = useNavigate()

    useEffect(() => {
        getOrders()
    }, [])

    const getOrders = () => {
        ApiHelper.get(API_ENDPOINTS.ORDERS).then((res) => {
            console.log('res: ',res);
            
            if (res.status === 200) {
                setOrders(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const imageBodyTemplate = (rowData) => {
        const courseCount = rowData?.courses?.length || 0;
        const firstCourse = rowData?.courses?.[0];
        const tooltipText = rowData?.courses?.map(c => c.courseName).filter(Boolean).join(',\n') || '';

        return (
            <div style={{ display: "flex", alignItems: "center", gap: "12px", minWidth: 0 }} title={tooltipText}>
                <div style={{ flexShrink: 0, width: '60px', height: '40px' }}>
                    {firstCourse?.courseImage && firstCourse?.courseImage !== 'null' ? (
                        <img
                            src={`${process.env.REACT_APP_BASE_URL}/${firstCourse?.courseImage}`}
                            alt=""
                            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }}
                            onError={(e) => {
                                e.target.src = "/img/placeholder-image.jpg"
                            }}
                        />
                    ) : (
                        <div style={{ width: '100%', height: '100%', background: '#e9ecef', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <i className="bi bi-journal-text text-secondary"></i>
                        </div>
                    )}
                </div>
                <div style={{ display: "flex", flexDirection: "column", minWidth: 0, flex: 1 }}>
                    <span style={{ fontWeight: '600', fontSize: '0.9rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {firstCourse?.courseName || 'Unknown Course'}
                    </span>
                    <span style={{ fontSize: '0.8rem', color: '#6b7280', marginTop: '2px' }}>
                        {courseCount} {courseCount === 1 ? 'Course' : 'Courses'}
                    </span>
                </div>
            </div>
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={`badge ${rowData.payemntStatus ? 'bg-success' : 'bg-danger'}`}>
                {rowData.payemntStatus ? 'Success' : 'Failed'}
            </span>
        );
    };

    // const actionBodyTemplate = (rowData) => {
    //     return (
    //         <>
    //             <button onClick={() => navigate(`/top-search/edit/${rowData.topSearchId}`)} className="btn btn-primary btn-sm me-2"> <i class="bi bi-pencil-square"></i> </button>
    //             <button onClick={() => confirmDeleteDailog(rowData.topSearchId)} className="btn btn-danger btn-sm"> <i class="bi bi-trash"></i> </button>
    //         </>
    //     );
    // };
    
    const userDetailBodyTemplate = (rowData) => {
        return (
            <>
                <span>{rowData.userName}</span>
                <br/>
                <span>{rowData.userMobileNumber}</span>
            </>
        );
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2"><span class="text-muted fw-light"><p className="breadcrumb-item active mb-0" aria-current="page">Orders</p></span></h4>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={orders} tableStyle={{ minWidth: '50rem' }} >
                                            <Column body={serialNoTemplate} header='S.NO' />
                                            <Column sortable header='User Detail' body={userDetailBodyTemplate} field='userName' />
                                            <Column sortable header='Courses' body={imageBodyTemplate} field='courses' />
                                            <Column sortable header='Order Date' field='createdAt' body={(rowData) => {
                                                const date = new Date(rowData.createdAt);
                                                return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: true, });
                                            }} />
                                            <Column sortable header='Order Number' field='orderNumber' />
                                            <Column sortable header='Total' field='grandTotal' />
                                            <Column sortable header='Razor Pay Id' field='razorpayOrderId' />
                                            <Column sortable header='Payment Method' field='paymentMethod' />
                                            <Column sortable header='Failed Reason' field='failureReason' />
                                            <Column sortable header='Status' body={statusBodyTemplate} field='paymentStatus' />
                                            {/* <Column sortable header='Action' body={actionBodyTemplate} /> */}
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default Orders
